import tokml from 'tokml';
import http from '../utils/http';
import i18n from '@/main';

export default {
    async getSafras() {
        return http.get({
            url: '/safra',
            lockScreen: false,
            lockMessage: i18n.t('mensagens.sistema.buscandoDadosDeSafras')
        });
    },
    async getSafrasVigentes() {
        return http.get({
            url: '/safra/vigentes',
            lockScreen: false,
            lockMessage: i18n.t('mensagens.sistema.buscandoDadosDeSafras')
        });
    },
    async getSafrasVigentesSise() {
        return http.get({
            url: '/safra/vigentes/sise',
            lockScreen: false,
            lockMessage: i18n.t('mensagens.sistema.buscandoDadosDeSafras')
        });
    },
    async getCulturas() {
        return http.get({
            url: `/culturas`,
            lockScreen: false,
            lockMessage: i18n.t('mensagens.sistema.aguardeBuscandoDadosDeCulturas')
        });
    },
    async getCulturasMonitoramento() {
        return http.get({
            url: `/culturas-monitoramento`,
            lockScreen: false,
            lockMessage: i18n.t('mensagens.sistema.aguardeBuscandoDadosDeCulturas')
        });
    },
    findAlertas(filtro) {
        return http.post({
            url: '/alertas',
            data: filtro,
            lockScreen: false
        });
    },
    getQuantitativos() {
        return http.get({
            url: '/quantitativos',
            lockScreen: true
        });
    },

    getDadosCAR(codigosCAR) {
        return http.post({
            url: `/cars`,
            data: codigosCAR,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoCarsSobrepostos')
        });
    },

    getDadosCARSemGeometria(codigo) {
        return http.get({
            url: `/car/${codigo}`,
            lockScreen: true,
            lockMessage: 'Buscando CARs'
        });
    },

    baixarKMLdeGeometria(geoJson) {
        const kml = tokml(geoJson);
        const convertedKML =
            'application/xml;charset=utf-8,' + encodeURIComponent(kml);

        const elDownload = document.createElement('a');
        elDownload.setAttribute('href', 'data:' + convertedKML);
        elDownload.setAttribute('download', 'poligono.kml');

        document.body.appendChild(elDownload);
        elDownload.click();
        document.body.removeChild(elDownload);
    },

    baixarArquivo(url) {
        const fileLink = document.createElement('a');
        try {
            return http
                .get({ url: `${url}`, responseType: 'blob' })
                .then(response => {
                    if (response.status === 200) {
                        const fileURL = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        fileLink.href = fileURL;

                        const filenameRegex =
                            /filename=['"]?([^;\r\n"']*)['"]?;?/;
                        const contentDisposition =
                            response.headers['content-disposition'];

                        fileLink.setAttribute(
                            'download',
                            filenameRegex.exec(contentDisposition)[1]
                        );
                        document.body.appendChild(fileLink);

                        fileLink.click();
                        return Promise.resolve();
                    }
                });
        } catch (error) {
            return Promise.reject(error);
        } finally {
            fileLink.remove();
        }
    },

    buscarTotalizadores() {
        return http.get({
            url: '/totalizador',
            lockScreen: false
        });
    },
    enviarPingWebsocket() {
        return http.get({
            url: '/ws/ping',
            lockScreen: false
        });
    },
    buscarTodasEmpresasSubEmpresas(pais) {
        return http.get({
            url: `/empresas-sub-empresas-pais?pais=${pais}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoEmpresas')
        });
    }
};
